 import React, { useState,useEffect } from "react";


//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { fetchTenants } from "../../../../redux/slices/sliceActions";

const TenantTable = ({ handleShowModal, setTenantData }) => {
  //data fetched
    const dispatch = useDispatch();
    const { user, profile,tenants:tenantsGotten } = useSelector(
      (state) => state.landlordslice
    );
    const token = user?.accessToken;
    const id = user?.user?.user_id;
    const property_id = user?.user?.propertyId;
  
  const [tenantsFetched, setTenantsFetched] = useState([]);

  useEffect(() => {
    console.log(user);
    dispatch(fetchTenants({ property_id, token }))
  }, [user]);

  useEffect(() => { 
    if(tenantsGotten.length > 0){
      setTenantsFetched(extractTenantInfo(tenantsGotten));
    }
  }, [tenantsGotten]);



  const tenants = tenantsFetched;
  const [visibleTenantsCount, setVisibleTenantsCount] = useState(5);

  const handleShowMore = () => {
    setVisibleTenantsCount((prevCount) => prevCount + 3); // Show 3 more tenants
  };

  const handleHideAll = () => {
    setVisibleTenantsCount(3); // Reset to initial count
  };


  const [expandedRow, setExpandedRow] = useState(null);
  const [hover, setHover] = useState(false);

  const handleRowClick = (tenantId) => {
    setExpandedRow(expandedRow === tenantId ? null : tenantId);
  };

  const styles = {
    card: {
      width: "97%",
      display: "flex",
      justifyContent: "space-between",
      marginTop: "10px",
      backgroundColor: "white",
      boxShadow: "rgba(0, 0, 0, 0.28) 0px 0px 5px 0px",
      padding: "7px 15px",
      borderRadius: "10px",
      alignItems: "center",
      cursor: "pointer",
    },
    firstSection: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },
    profilePicture: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
    },
    placeHolder: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      backgroundColor: "#192A3A",
    },
    dateJoined: {
      color: "#9d9d9d",
      fontSize: "14px",
      fontFamily: "Karla, sans-serif",
      marginTop: "4px",
    },
    apartmentNumber: {
      color: "#B39359",
    },
    expandedContent: {
      width: "97%",
      margin: "20px 0px",
      padding: "1rem",
      backgroundColor: "rgb(255, 255, 255)",
      border: "1px solid rgb(221, 221, 221)",
      borderRadius: "5px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    expandedTitle: {
      color: "#192A3A",
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "10px",
      fontFamily: "Karla, sans-serif",
    },
    expandedRow: {
      display: "flex",
      justifyContent: "space-between",
      width: "40%",
      marginBottom: "10px",
    },
    expandedSubTitle: {
      fontSize: "16px",
      fontFamily: "Poppins,sans-serif",
      fontWeight: "200",
    },
    expandedDetails: {
      fontFamily: "Poppins,sans-serif",
      fontWeight: "400",
      fontSize: "16px",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "10px",
      alignItems: "center",
    },
    button: {
      backgroundColor: hover ? "#B39359" : "#192A3A",
      color: "white",
      padding: "7px 10px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      marginTop: "10px",
      fontSize: "16px",
      fontWeight: "200",
      transition:"background-color 0.3s ease",
    },
    
  };

  return (
    <div>
      {tenants.length > 0 ? (<>
        {tenants.slice(0, visibleTenantsCount).map((tenant, index) => (
        <>
          <div style={styles.card} onClick={() => handleRowClick(tenant.id)}>
            <div style={styles.firstSection}>
              {tenant?.profilePicture ? (
                <div>
                  <img
                    style={styles.profilePicture}
                    src={tenant.profilePicture}
                    alt={`${tenant.name}'s profile`}
                  />
                </div>
              ) : (
                <div style={styles.placeHolder}></div>
              )}
              <div>
                <div>{tenant.name}</div>
                <div style={styles.dateJoined}>{tenant.dateJoined}</div>
              </div>
            </div>
            <div> {tenant.email}</div>
            <div style={styles.apartmentNumber}>{tenant.apartmentNumber}</div>
          </div>
          {expandedRow === tenant.id && (
            <div style={styles.expandedContent}>
              <div style={styles.expandedTitle}>Tenant Details</div>
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>Tenant Id:</div>{" "}
                <div style={styles.expandedDetails}>{tenant.id}</div>
              </div>
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>Phone Number:</div>{" "}
                <div style={styles.expandedDetails}>{tenant.phoneNumber}</div>
              </div>
                 */}
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>House Type:</div>{" "}
                <div style={styles.expandedDetails}>{tenant.houseType}</div>
              </div>
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>Email:</div>{" "}
                <div style={styles.expandedDetails}>{tenant.email}</div>
              </div>
              <div
                style={styles.button}
                onClick={() => {
                  handleShowModal("modify tenant");
                  setTenantData({
                    id: tenant.id,
                    name: tenant.name,
                    dateJoined: tenant.dateJoined,
                    apartmentNumber: tenant.apartmentNumber,
                    email: tenant.email,
                    houseType: tenant.houseType,
                    firstName: tenant.name.split(" ")[0],
                    lastName: tenant.name.split(" ")[1],
                    phoneNumber: tenant.phoneNumber,
                    nationalID: tenant.nationalID,
                    house_id: tenant.houseId,
                    emergency_contact_phone: tenant.emergency_contact_phone,
                  });
                }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
              >
                Edit Tenant
              </div>
            </div>
          )}
        </>
        ))}
        {/* Show More and Hide All Buttons */}
        <div style={styles?.buttonContainer}>
        {visibleTenantsCount < tenants.length && (
            <div style={{ marginTop: "10px" }}>
              <button style={styles.button} onClick={handleShowMore}>
                Show More
              </button>
            </div>
          )}
          {visibleTenantsCount > 5 && (
            <div style={{ marginTop: "10px" }}>
              <button style={styles.button} onClick={handleHideAll}>
                Hide All
              </button>
            </div>
          )}
      </div>
      
      </>) : (<div>No tenants available</div>)}
    </div>
  );
};


function extractTenantInfo(tenants) {
  console.log("my tenants",tenants);
  return tenants.map((tenant, index) => {
    return {
      // id: `T${(tenant.tenant_id + 1).toString().padStart(3, '0')}`, // Assigns an ID like T001
      id: tenant.tenant_id,
      name: tenant.tenant_name || "N/A", // Using caretaker name
      dateJoined: new Date(tenant.created_at).toLocaleString('en-US', { month: 'long', year: 'numeric' }), // Formatting the date
      apartmentNumber: tenant.house.house_number || "N/A", // Apartment number
      email: tenant.tenant_email || "N/A", // Caretaker email
      phoneNumber: tenant.tenant_phone_number || "N/A", // Caretaker phone number
      houseType: tenant.house.house_type || "N/A", // House type
      houseId: tenant.house.house_id || "N/A", // House ID
      nationalID: tenant.tenant_id_number || "N/A", // National ID
      profilePicture: "", // No profile picture provided
      emergency_contact_phone: tenant.emergency_contact_phone || "N/A",
    };
  });
}


export default TenantTable;
